<template>
  <um-page class="page-virtual-home">
    <div class="virtual-home-container">
      <HomeHeader></HomeHeader>
      <div class="home-body">
        <div class="cover-wrapper" :style="{'background-image': 'url('+ buildResourcePath(virtual.cover) +')'}">
        </div>
        <div class="virtual-detail">
          <div class="title">{{virtual.title}}</div>
          <div class="teacher">教师：{{virtual.teacherName}}</div>
          <ul class="info-list">
            <li>
              <div class="value">{{virtual.pageView || 0}}</div>
              <div class="label"> <i class="iconfont icon-pageviews_stroke"></i><span>浏览量</span></div>
            </li>
            <li>
              <div class="value">{{virtual.experimentTimes || 0}}</div>
              <div class="label"> <i class="iconfont icon-person-times_stroke"></i><span>实验人次</span></div>
            </li>
            <li>
              <div class="value">{{virtual.experimentPeoples || 0}}</div>
              <div class="label"> <i class="iconfont icon-person-number_stroke"></i><span>实验人数</span></div>
            </li>
            <li>
              <div class="value">{{virtual.averageTime | duration}}</div>
              <div class="label"> <i class="iconfont icon-xunifangzhen_shiyanleijiyongshi"></i><span>实验平均用时</span></div>
            </li>
            <li>
              <div class="value">{{virtual.passRate || 0}}%</div>
              <div class="label"> <i class="iconfont icon-pass-rate_stroke"></i><span>实验通过率</span></div>
            </li>
          </ul>
        </div>
        <div class="tabs-wrapper">
          <div class="tabs">
            <div class="tab" :class="{'is-active': tabIndex === 0}" @click="tabChange(0)">实验介绍</div>
            <div class="tab" :class="{'is-active': tabIndex === 1}" @click="tabChange(1)">实验指南</div>
            <div class="tab" :class="{'is-active': tabIndex === 2}"  @click="tabChange(2)">师资介绍</div>
          </div>
        </div>
        <div class="tab-content tab-detail" v-show="tabIndex === 0">
          <richtext :content="virtual.experimentIntroduce"></richtext>
        </div>
        <div class="tab-content tab-index" v-show="tabIndex === 1">
          <richtext :content="virtual.guideIntroduce"></richtext>
        </div>
        <div class="tab-content tab-index" v-show="tabIndex === 2">
          <richtext :content="virtual.teacherIntroduction"></richtext>
        </div>
      </div>
      <div class="btn-bottom">
      <button class="button button-primary" @click="startTest"> <i class="iconfont icon-xunifangzhen_shiyancishu"></i> 开始实验</button>
      </div>
    </div>
  </um-page>
</template>

<script>
import { device } from '@/utils/device.js'
if (!device.isMobile) {
  location.href = location.href.replace('mobile.html', 'pc.html')
}
import HomeHeader from 'mobile/components/Page/homeHeader'
import { mapGetters } from 'vuex'
import { getVirtualExperimentUrl, getVirtualExperimentDetail, updateVirtualHomeViewTimes } from '@/api/courseApi/virtual.js'
import cookies from '@/utils/cookie'
import Confirm from 'pc/components/confirm'
import { formatSeconds } from '@/utils'
import Richtext from 'mobile/components/Richtext/richtext.vue'
import { buildResourcePath } from '@/utils'
import { hostDomain, UMOOC_WEB_HOST } from '@/config'
export default {
  name: 'page-virtual-home',
  data () {
    return {
      tabIndex: 0,
      virtual: {

      }
    }
  },
  computed: {
    ...mapGetters({'user': 'user/user', 'org': 'org/org'}),
    experimentId () {
      return this.$route.params.id
    }
  },
  created () {
    window.virtual = this
    this.getVirtualDetail()
  },
  mounted () {
    this.updateViewTimes()
  },
  methods: {
    buildResourcePath,
    getVirtualDetail () {
      getVirtualExperimentDetail({experimentId: this.experimentId})
        .then(({result}) => {
          this.virtual = result
        })
    },
    updateViewTimes () {
      updateVirtualHomeViewTimes({experimentId: this.experimentId})
    },
    tabChange (index) {
      this.tabIndex = index
    },
    startTest () {
      if (this.user.userId) {
        if (this.user.role == 8) {
          // 当前登录的是教师帐号，请切换到学生模式再开始实验！
          this.$dialog.confirm({
            message: '当前登录的是教师帐号，请切换到学生模式再开始实验！',
            confirmButtonText: '切换到学生模式',
            messageAlign: 'left'
          })
          .then(() => {
            this.switchRole()
          })
        } else if (this.user.role == 9) {
          getVirtualExperimentUrl({experimentId: this.experimentId})
            .then(({result}) => {
              window.open(result)
            })
        } 
        
      } else {
        this.toLogin()
      }
    },
    switchRole () {
      this.user.switchRole()
    },
    logout () {
      this.user.logout()
    },
    toLogin () {
      cookies.set('loginRedirectUrl', location.href)
      let url = `${UMOOC_WEB_HOST}/pc.html#/login`
      if (!this.org.isMainSite) {
        url = `https://${this.org.prefix + hostDomain}/sld/pc.html#/login`
      }
      location.href = url
    },
  },
  filters: {
    duration (time) {
      if (time === undefined) {
        return '--'
      }
      return formatSeconds(time)
    },
  },
  components: {
    HomeHeader,
    Richtext
  }
}
</script>

<style lang="scss" scoped>

.virtual-home-container{
  display: flex;
  height: 100%;
  flex-direction: column;
}
.home-body{
  flex: 1;
  height: 0;
  overflow: auto;
  .cover-wrapper{
    position: relative;
    padding-bottom: 56.25%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .video-wrapper{
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }
}
.virtual-detail{
  padding: 16px 10px;
  border-bottom: solid 12px #f8f8f8;
  .title{
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 26px;
    font-weight: 600;
  }
  .teacher{
    font-size: 16px;
    line-height: 24px;
  }
  .info-list{
    display: flex;
    flex-wrap: wrap;
    
    li{
      width: 33.3333%;
      margin-top: 16px;
      padding-right: 16px;
      box-sizing: border-box;
      line-height: 1;
      .value{
        font-size: 18px;
      }
      .label{
        margin-top: 8px;
        color: $--color-text-secondary;
        i{
          margin-right: 4px;
          font-size: 14px;
        }
      }
    }
  }
}
.tabs-wrapper{
  border-bottom: $--border-base;
}
.tabs{
  display: flex;
  justify-content: space-around;
  .tab{
    padding: 10px 0;
    margin: 0 20px;
    line-height: 24px;
    font-size: 16px;
    cursor: pointer;
    &:hover{
      color: $--color-primary;
    }
    &.is-active{
      border-bottom: solid 3px $--color-primary;
      color: $--color-primary;
    }
  }
}
.tab-content{
  padding: 20px 10px;
}
.btn-bottom{
  padding: 20px;
  .button i{
    font-size: 14px;
  }
}
</style>